export const dbConfigUrl = '/admin/dbconfigs';
